import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BellRing, FileClock, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Standing admin reminder: unsent weekly drafts + released runs with a pending revision. Re-fetches whenever `refreshKey` changes. */
export const PayrollAttentionBanner = ({ isAdmin, refreshKey }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!isAdmin) return undefined;
    let active = true;
    axios.get(`${API}/payrolls/attention`, { withCredentials: true })
      .then((r) => { if (active) setData(r.data); })
      .catch(() => { if (active) setData(null); });
    return () => { active = false; };
  }, [isAdmin, refreshKey]);
  if (!isAdmin || !data || !data.total) return null;
  return (
    <div data-testid="payroll-attention-banner" className="mb-6 rounded-md border border-amber-300 bg-amber-50 px-4 py-3" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <BellRing className="h-4 w-4 text-amber-600" />
        <span data-testid="payroll-attention-count">{data.total}</span> payroll{data.total === 1 ? '' : 's'} need{data.total === 1 ? 's' : ''} your attention — nothing is sent to drivers until you release it.
      </p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {data.items.map((it) => (
          <li key={`${it.kind}-${it.payroll_id}`}>
            <button type="button" data-testid={`payroll-attention-item-${it.payroll_id}`} onClick={() => navigate(`/payroll/${it.open_id}`)}
              className="flex items-center gap-2 rounded-md border border-amber-300 bg-white px-3 py-1.5 text-xs text-slate-800 hover:bg-amber-100">
              {it.kind === 'pending_revision' ? <FileClock className="h-3.5 w-3.5 text-blue-600" /> : <Clock className="h-3.5 w-3.5 text-slate-500" />}
              <span className="font-semibold">{it.payroll_week_number ? `Week ${it.payroll_week_number}${it.payroll_year ? ` · ${it.payroll_year}` : ''}` : 'Pay week'}</span>
              <span className="text-slate-600">{it.week_start} → {it.week_end}</span>
              <span className={`rounded px-1.5 py-0.5 text-[10px] font-bold uppercase ${it.kind === 'pending_revision' ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-slate-700'}`}>{it.kind === 'pending_revision' ? 'Pending revision' : 'Draft'}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
